<template lang='pug'>
	.headerImageFull
		.contenedor-headerImageFull
			.contenido
				.modulo.modulo-1
					.ico
						img.icono1(src='~Img/baseline-business-24px.svg')
					h2.caja-texto1
						| Accurate, Fast & Economical Title 24 Compliance Solutions for Building Designers, Owners and Contractors
				.modulo.modulo-2
					.ico
						img.icono2(src='~Img/baseline-assignment_turned_in-24px.svg')
					.texto-boton
						h2.caja-texto2
							| Is Title 24 Compliance Required for my Project?
						h2.caja-texto3
							| If so, how much will the analysis cost?
						router-link.btn(to='/compliance-wizard')
							span
								| Check my project
</template>

<script>
export default {
	name: 'headerImageFull'
}
</script>



// WEBPACK FOOTER //
// src/components/home/HeaderImageFull.vue